import { AuthState } from '@okta/okta-auth-js';

import { Hello } from '../services/backend/Hello';

import { useBaseApiClient } from './useBaseApiClient';

export const useHelloClient: () => Hello<AuthState> = () => {
  return useBaseApiClient(Hello);
};
